import {
  Box,
  Typography,
  Stack,
  Button,
  AppBar,
  Container,
  Toolbar,
  Icon,
  CssBaseline,
  List,
  ListItem,
} from "@mui/material";
import pepIcon from "../../images/pepElaOutlined.png";

import gov from "../../images/home/gov.png";
import revela from "../../images/home/revela.png";
import lais from "../../images/home/lais.png";
import group from "../../images/home/group.png";
import pepEla from "../../images/home/pepElaLogo.png";
import wave from "../../images/home/wave.png";
import waveLeft from "../../images/home/waveLeft.png";
import { useNavigate } from "react-router-dom";

const ImageFooter = ({ imageSrc, imageAlt }) => {
  return (
    <Stack
      sx={{ transition: "height 0.3s ease" }}
      height={{ xs: "66px", sm: "46px", md: "56px", lg: "66px" }}
    >
      <Icon style={{ width: "auto", height: "100%" }}>
        <img src={imageSrc} alt={imageAlt} height="100%" />
      </Icon>
    </Stack>
  );
};

export default function NotFound(params) {
  const navigate = useNavigate();
  return (
    <Box
      sx={{
        width: "100vw",
        height: "100vh",
        overflowX: "hidden",
        lineHeight: "22px",
      }}
    >
      <CssBaseline />

      <AppBar
        position="static"
        sx={{
          display: "flex",
          width: "100%",
          height: "80px",
          justifyContent: "center",
          zIndex: 10,
        }}
      >
        <Container
          maxWidth="100vw"
          sx={{
            backgroundColor: "#3E94C2",
            height: "80px",
            zIndex: 10,
            display: "flex",
          }}
        >
          <Toolbar>
            <Stack
              direction={"row"}
              width={"100%"}
              alignItems="center"
              height={{ xs: "40px", sm: "54px" }}
              sx={{ transition: "height 0.3s ease" }}
            >
              <Icon style={{ width: "auto", height: "100%" }}>
                <img
                  style={{ width: "auto", height: "100%" }}
                  src={pepIcon}
                  alt={"Icone Pep"}
                />
              </Icon>
            </Stack>
          </Toolbar>
        </Container>
      </AppBar>

      <Stack
        position="relative"
        width={"100%"}
        sx={{
          minHeight: "calc(100vh - 180px)",
        }}
      >
        <Stack
          position="absolute"
          sx={{
            backgroundSize: "cover",
            backgroundImage: `url(${waveLeft})`,
            backgroundRepeat: "no-repeat",
            backgroundPosition: "-20px -60px ",
            width: "750px",
            height: "430px",
          }}
        ></Stack>
        <Stack
          position="absolute"
          sx={{
            backgroundSize: "cover",
            backgroundImage: `url(${wave})`,
            backgroundRepeat: "no-repeat",
            backgroundPosition: "-11px 26px",
            right: "-78px",
            width: "1100.23px",
            bottom: "0px",
            height: "833px",
            transform: "rotate(351deg)",
          }}
        ></Stack>
        <Stack
          height={"100%"}
          maxWidth={"1350px"}
          width={"100%"}
          flexDirection="column"
          display="flex"
          gap="16px"
          sx={{
            margin: "0 auto",
            minHeight: "calc(100vh - 190px)",
            padding: "48px",
            paddingBottom: "60px",
            zIndex: 10,
          }}
        >
          <Typography
            component="h1"
            sx={{
              fontFamily: "Nunito",
              fontSize: "4rem",
              fontWeight: 700,
              lineHeight: "4rem",
              color: "#265974",
            }}
          >
            404
          </Typography>
          <Typography
            component="h2"
            sx={{
              fontFamily: "Nunito",
              fontSize: "2rem",
              fontWeight: 600,
              lineHeight: "2rem",
              color: "#265974",
            }}
          >
            Não encontramos a página que você procurou :(
          </Typography>
          <Typography
            sx={{
              fontFamily: "Nunito",
              fontSize: "1.5rem",
              fontWeight: 600,
              lineHeight: "1.5rem",
              color: "#265974",
            }}
          >
            O que pode ter ocorrido?
          </Typography>
          <List
            sx={{
              fontFamily: "Nunito",
              fontSize: "1.2rem",
              fontWeight: 500,
              lineHeight: "1.2rem",
              color: "#265974",
              padding: "0px",
            }}
          >
            <ListItem> &gt; A página pode ter sido removida.</ListItem>
            <ListItem>
              &gt; A página pode estar temporariamente indisponível.
            </ListItem>
            <ListItem>
              &gt; Você pode ter digitado o endereço incorreto na URL.
            </ListItem>
          </List>
          <Button
            sx={{ maxWidth: "260px", background: "#3E94C2", marginTop: "15px" }}
            variant="contained"
            onClick={() => navigate("/")}
          >
            Voltar para home
          </Button>
        </Stack>
      </Stack>

      <Stack
        height={{ xs: "430px", sm: "100px" }}
        position="relative"
        width="100%"
        bgcolor="#D3E3EB"
        zIndex={10}
      >
        <Stack
          direction={{ xs: "column", sm: "row", md: "row" }}
          height={{ xs: "430px", sm: "100px" }}
          justifyContent="space-evenly"
          alignItems="center"
        >
          <ImageFooter imageAlt={"Governo Federal"} imageSrc={gov} />
          <ImageFooter
            imageAlt={"Laboratório de Inovação Tecnológica em Saúde"}
            imageSrc={lais}
          />
          <ImageFooter imageAlt={"Projeto RevELA"} imageSrc={revela} />
          <ImageFooter imageAlt={"Prontuário Eletrônico"} imageSrc={pepEla} />
          <ImageFooter
            imageAlt={"Hospital universitário Onofre Lopes"}
            imageSrc={group}
          />
        </Stack>
      </Stack>
    </Box>
  );
}
